import React from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import { noHeaderCss } from "../../../sass/Main";
import { connect } from "react-redux";
import Grid from "@material-ui/core/Grid";
import slackLogo from "../assets/slack_logo.svg";
import teamsLogo from "../assets/teams_logo.svg";
import workflowIcon from "../assets/workflow.svg";
import PaperHeader from "../PaperHeader";
import {CircularProgress, Paper, Divider, Typography, Card, CardActionArea, CardMedia, CardContent} from "@material-ui/core";
import { pushMessage } from "../../../redux/actions/commonActions";



  
class InstallCollaborationToolScreen extends React.Component {

  componentDidMount() {
    localStorage.removeItem('ConnectionId');
    localStorage.removeItem('connected');
  }

  openInstallationScreen = (url) => {
    window.open(url, "_blank");
  }

  openVoicehub = () => {
    window.open("/");
  } 

  renderSpinner = () => {
    return <CircularProgress color="secondary" />;
  };


  render() {
    const { classes } = this.props;
    let title = true?"You’re almost done!  Now it’s time to add the Slack app to your account.  Click the icon below to access the Responsum app in the Slack (Teams) App Directory and then select Add to Slack.  Then access Responsum in your Slack under the Apps section and start chatting!"
                   :"You’re almost done!  Now it’s time to add the Teams app to your account.  In Teams, go to the Apps icon in the left menu bar and search for Responsum.  Click the Add button and start chatting!";
    return (
      <>
        <PaperHeader text={title} />
            <br />
        <Grid container direction="center" justify="center" alignItems="center" spacing={2}>
          <Grid item>
            <Paper onClick={() => this.openInstallationScreen("https://test-sxr6746.slack.com/apps/A024R9PQM-zapier")} className={classes.installCard} elevation={1}>
                <img src={slackLogo} style={{width: "90%"}} />
            </Paper>
          </Grid>   
        </Grid>
        <br /><br /><br />
        <Divider />
        <br /><br /> 
        <p>You can also access your dashboard and configure Responsum to your needs.</p>
        <br />
        <Grid container direction="center" justify="center" alignItems="center" spacing={2}>
          <Grid item>
                <Paper onClick={() => this.openVoicehub()} className={classes.installCard} elevation={1} >
                    <img src={workflowIcon} style={{height: "90%", marginRight: 15}} />
                  <p><strong>Skills</strong></p>
                </Paper>
            </Grid>   
        </Grid>
      </>
    );
  }
}

const InstallCollaborationToolScreenStyled = withStyles(noHeaderCss)(InstallCollaborationToolScreen);

const mapStateToProps = state => {
  return {
    featuredConnectors: state.gettingStartedWizard.featuredConnectors
  };
};

export default connect(
  mapStateToProps,
  {
   pushMessage,
  }
)(InstallCollaborationToolScreenStyled);
